import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';
import { DashboardSectionTitle } from './DashboardSectionTitle';
import { formatKilos, formatPercent } from '../../utils/flujoCalculations';

export const WarehouseDistributionCard = ({ title = 'Kilos por almacen', rows, colors = {} }) => {
  const total = rows.reduce((acc, row) => acc + row.value, 0);
  const maxValue = Math.max(...rows.map((row) => row.value), 1);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        height: '100%',
      }}
    >
      <DashboardSectionTitle icon={<WarehouseOutlinedIcon />} sx={{ mb: 2 }}>
        {title}
      </DashboardSectionTitle>

      <Stack spacing={1.7}>
        {rows.map((row) => {
          const percent = total > 0 ? (row.value * 100) / total : 0;
          const width = maxValue > 0 ? (row.value * 100) / maxValue : 0;

          return (
            <Box key={row.idAlmacen}>
              <Stack
                direction="row"
                spacing={2}
                sx={{ justifyContent: 'space-between', alignItems: 'baseline', mb: 0.75 }}
              >
                <Stack direction="row" spacing={0.75} sx={{ alignItems: 'center', minWidth: 0 }}>
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: '50%',
                      bgcolor: colors[row.idAlmacen] || 'primary.main',
                      flex: '0 0 auto',
                    }}
                  />
                  <Typography sx={{ fontSize: 14, fontWeight: 900 }}>
                    {row.almacen}
                  </Typography>
                </Stack>
                <Typography sx={{ fontSize: 13, color: 'text.secondary', fontWeight: 800 }}>
                  {formatKilos(row.value)} kg - {formatPercent(percent)} %
                </Typography>
              </Stack>
              <Box
                sx={{
                  height: 8,
                  borderRadius: 1,
                  bgcolor: '#e5e7eb',
                  overflow: 'hidden',
                }}
              >
                <Box
                  sx={{
                    width: `${width}%`,
                    height: '100%',
                    bgcolor: colors[row.idAlmacen] || 'primary.main',
                  }}
                />
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
};
